import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface SkeletonCardProps {
  className?: string;
  children: ReactNode;
}

export function SkeletonCard(props: SkeletonCardProps) {
  const { className, children } = props;

  return (
    <div
      className={twMerge(
        'w-full flex flex-col rounded-[24px] pt-[16px] px-[16px] overflow-hidden bg-pmw-surface-foreground-light dark:bg-pmw-surface-foreground-dark',
        className,
      )}
    >
      {children}
    </div>
  );
}
